






import Vue from "vue";
import VerifyMtaCode from "@/components/templates/VerifyMTACode/index.vue";

export default Vue.extend({
  components: { VerifyMtaCode },
  methods: {
    verifyMFACode(mfacode: string) {
      this.$store.dispatch("auth/verifyMFACode", mfacode)
      .then((props) => {
        if (props.status && props.status === "done") {
          const nextPath = props.path ? `/${props.path}` : "/dashboard";
          this.$router.push(nextPath);
        }
      });
    },
  },
});
